import * as yup from 'yup';

import { convertYupErrorToMessagesObject } from '@shared/utils/validation.utils';
import { ERROR_MESSAGES } from '../sign-up/sign-up.constants';
import { getFederatedLoginConfigByEmail } from '../auth-service';

const schema = yup.object().shape({
    username: yup.string()
        .email(ERROR_MESSAGES.INVALID_EMAIL)
        .test('federatedEmail', ERROR_MESSAGES.FEDERATED_EMAIL, async (email: string) => {
            const federatedLoginConfig = await getFederatedLoginConfigByEmail(email);
            return !federatedLoginConfig;
        })
        .required(ERROR_MESSAGES.REQUIRED_EMAIL),
});

export const validateForgotPassword = data => (
    schema.validate(data, { convert: true, abortEarly: false }).catch(error => (
        Promise.reject(convertYupErrorToMessagesObject(error))
    ))
);
